import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "recent-lab-reports-card trezo-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "basic-table table-responsive" }
const _hoisted_4 = { class: "table mb-0" }
const _hoisted_5 = { class: "employee-info d-flex" }
const _hoisted_6 = { class: "img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "d-block fw-semibold" }
const _hoisted_9 = { class: "d-block text-body" }
const _hoisted_10 = { class: "fw-normal text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "trezo-card-header d-flex align-items-center justify-content-between" }, [
      _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Recent Lab Reports")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labReports, (report, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        src: _ctx.getIcon(report.type),
                        alt: "user-image"
                      }, null, 8, _hoisted_7)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(report.name), 1),
                      _createElementVNode("span", _hoisted_9, [
                        _cache[0] || (_cache[0] = _createTextVNode(" submitted by ", -1)),
                        _createElementVNode("strong", _hoisted_10, _toDisplayString(report.submittedBy), 1)
                      ])
                    ])
                  ])
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "download-btn d-inline-block text-primary lh-1 border-0 bg-transparent p-0"
                  }, [
                    _createElementVNode("i", { class: "ri-download-2-line" })
                  ])
                ], -1))
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}